import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { DatabaseMetaDataFragmentDoc } from '../../../../../../database/graphql/fragments/generated/DatabaseMetadata';
import { DatabaseMetadataFieldFragmentDoc } from '../../../../../../database/graphql/fragments/generated/DatabaseMetadataField';
import { DatabaseViewFragmentDoc } from '../../../../../../database/graphql/fragments/generated/DatabaseView';
import { DatabaseViewFieldFragmentDoc } from '../../../../../../database/graphql/fragments/generated/DatabaseViewField';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type SurveyDetailsContentFragment = { id: string, name: string, description?: string | null, status: Types.ResourceStatusEnum, coverOffset?: number | null, dbMetadataId: string, type: Types.ResourceTypeEnum, duration: number, languageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, defaultLanguageType?: Types.LanguageEnum | null, sourceLanguageContentId?: string | null, lastContentEditTimeAt?: string | null, databaseMetadata?: { id: string, dbId: string, dbName: string, dbDefaultViewId: string, views?: Array<{ id: string, name: string, viewType: Types.ViewTypeEnum }> | null, fields: Array<{ name: string, type: Types.DatabaseFieldTypeEnum, fieldId: string, numberFormat?: Types.DatabaseNumberFormatEnum | null, dateFormat?: string | null, ratingType?: Types.DatabaseRatingTypeEnum | null, collectionType?: Types.DatabaseRelationCollectionTypeEnum | null, validation?: { maxValue?: number | null, maxLength?: number | null } | null, options?: Array<{ value: string, color: string, optionId: string }> | null }> } | null, databaseViews?: Array<{ id: string, viewType: Types.ViewTypeEnum, format: { fields: Array<{ label?: string | null, width: number, fieldId: string, visible: boolean, required: boolean, description?: string | null, placeholder?: string | null, textType?: Types.DatabaseTextFormatEnum | null, allowCustomOptions?: boolean | null, descriptionEnabled?: boolean | null, minLabel?: string | null, maxLabel?: string | null }> }, query?: { sort?: Array<{ order: Types.OrderEnum, property: string }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ value?: string | null, property?: string | null, operator: Types.FilterOperatorEnum, filters: Array<{ value: string, property: string, operator: Types.FilterOperatorEnum }> }> } | null } | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, parentContentProfile?: { type: Types.ResourceTypeEnum, id: string } | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, recalibrationRequired: boolean, enrolmentInfo?: { dueDate?: string | null } | null } | null, bookmark?: { id: string } | null, userPermissions?: Array<{ action: Types.ResourceActions, subject: Types.ResourceSubjects }> | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum }> | null, sourceContent?: { id: string, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum }> | null } | {} | null };


export type SurveyDetailsContentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SurveyDetailsContentFragmentDoc = /*#__PURE__*/ gql`
    fragment SurveyDetailsContent on SurveyContentType {
  id
  name
  description
  status
  coverOffset
  dbMetadataId
  databaseMetadata {
    ...DatabaseMetaData
  }
  databaseViews {
    ...DatabaseView
  }
  sharedByWorkspace {
    ...SharedByWorkspace
  }
  parentContentProfile(parentContentId: $parentContentId) {
    type
    id
  }
  type
  duration
  cover {
    ...EntityMedia
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
    recalibrationRequired
    enrolmentInfo {
      dueDate
    }
  }
  bookmark {
    id
  }
  userPermissions {
    action
    subject
  }
  languageConfigs {
    contentId
    languageType
  }
  languageType
  isLocalizedContent
  sourceContent {
    ... on SurveyContentType {
      id
      languageType
      languageConfigs {
        contentId
        languageType
      }
      defaultLanguageType
    }
  }
  defaultLanguageType
  sourceLanguageContentId
  lastContentEditTimeAt
}
    `;